import './CreateAreaForm.svelte.css';
/* src/components/CreateAreaForm.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_store_value,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import uuid from "../../_snowpack/pkg/uuid-v4.js";
import { SubmitButton } from "./button-elements/index.js";
import { areas } from "../stores/index.js";
import { createAreaJdId } from "../utils/jd-id-builder.js";
import { MAX_AREA_COUNT } from "../data/constants.js";

function create_default_slot(ctx) {
	let t;

	return {
		c() {
			t = text("add");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let form;
	let code;

	let t0_value = createAreaJdId((/*$areas*/ ctx[2]?.length)
	? /*$areas*/ ctx[2].length + 1
	: 1) + "";

	let t0;
	let t1;
	let label;
	let t3;
	let input;
	let t4;
	let submitbutton;
	let current;
	let mounted;
	let dispose;

	submitbutton = new SubmitButton({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			form = element("form");
			code = element("code");
			t0 = text(t0_value);
			t1 = space();
			label = element("label");
			label.textContent = "add new area";
			t3 = space();
			input = element("input");
			t4 = space();
			create_component(submitbutton.$$.fragment);
			attr(code, "class", "jd-id svelte-554dml");
			attr(label, "for", "area-name-input");
			attr(input, "id", "area-name-input");
			attr(input, "class", "jd-text-input svelte-554dml");
			attr(input, "type", "text");
			attr(input, "placeholder", "new area");
			attr(input, "autocomplete", "off");
			attr(form, "class", "jd-form-set svelte-554dml");
			attr(div, "class", "svelte-554dml");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, form);
			append(form, code);
			append(code, t0);
			append(form, t1);
			append(form, label);
			append(form, t3);
			append(form, input);
			/*input_binding*/ ctx[4](input);
			set_input_value(input, /*areaName*/ ctx[0]);
			append(form, t4);
			mount_component(submitbutton, form, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[5]),
					listen(form, "submit", /*handleAdd*/ ctx[3])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*$areas*/ 4) && t0_value !== (t0_value = createAreaJdId((/*$areas*/ ctx[2]?.length)
			? /*$areas*/ ctx[2].length + 1
			: 1) + "")) set_data(t0, t0_value);

			if (dirty & /*areaName*/ 1 && input.value !== /*areaName*/ ctx[0]) {
				set_input_value(input, /*areaName*/ ctx[0]);
			}

			const submitbutton_changes = {};

			if (dirty & /*$$scope*/ 64) {
				submitbutton_changes.$$scope = { dirty, ctx };
			}

			submitbutton.$set(submitbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(submitbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(submitbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			/*input_binding*/ ctx[4](null);
			destroy_component(submitbutton);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $areas;
	component_subscribe($$self, areas, $$value => $$invalidate(2, $areas = $$value));
	
	let areaName = "";
	let inputRef;

	const handleAdd = event => {
		event.preventDefault();
		if (!areaName) return alert("please fill in name");

		if (($areas === null || $areas === void 0
		? void 0
		: $areas.length) >= MAX_AREA_COUNT) return alert("you cannot create a new area");

		const newIndex = $areas ? $areas.length + 1 : 1;

		const newArea = {
			id: uuid(),
			order: newIndex,
			name: areaName
		};

		set_store_value(areas, $areas = $areas ? $areas.concat([newArea]) : [newArea], $areas);

		setTimeout(
			() => {
				$$invalidate(0, areaName = null);
				if (inputRef) inputRef.focus();
			},
			100
		);
	};

	function input_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			inputRef = $$value;
			$$invalidate(1, inputRef);
		});
	}

	function input_input_handler() {
		areaName = this.value;
		$$invalidate(0, areaName);
	}

	return [areaName, inputRef, $areas, handleAdd, input_binding, input_input_handler];
}

class CreateAreaForm extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default CreateAreaForm;